import React from 'react';
import { Coffee, Landmark, Croissant, Phone, MapPin, Mail, ExternalLink, ParkingSquare, Accessibility } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';
import './Info.css';

const Info = () => {
    const { settings } = useSettings();
    const mapEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(settings.address || '102 rue Porta, 81000 Albi')}&output=embed`;

    return (
        <section id="contact" className="info-section">
            <div className="container">

                {/* Contact/Location */}
                <div className="contact-container">
                    <div className="contact-info">
                        <h2>Nous Trouver</h2>
                        <div className="address" style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
                            <MapPin className="text-gold" size={24} style={{ marginTop: '5px', flexShrink: 0 }} />
                            <div>
                                <strong>{settings.siteName.toUpperCase()}</strong><br />
                                {settings.address.split(',')[0]}<br />
                                {settings.address.split(',')[1] || ''}
                            </div>
                        </div>
                        <p className="phone" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <Phone className="text-gold" size={24} />
                            <span>{settings.phone}</span>
                        </p>

                        <div className="actions">
                            <a href={`mailto:${settings.email}`} className="btn" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                <Mail size={18} /> Envoyer un email
                            </a>
                            <a href={settings.googleMapsUrl || `https://maps.google.com/?q=${encodeURIComponent(settings.address)}`} target="_blank" rel="noopener noreferrer" className="btn-outline" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                <ExternalLink size={18} /> Localiser notre point de vente
                            </a>
                        </div>
                    </div>
                    <div className="map-container">
                        <iframe
                            src={mapEmbedUrl}
                            className="iframe-map"
                            allowFullScreen=""
                            loading="lazy"
                            title="Map"
                        ></iframe>
                    </div>
                </div>

                {/* Continuous Services Slider */}
                <div className="features-marquee-section">
                    <div className="marquee-wrapper">
                        <div className="marquee-content">
                            {/* Set 1 */}
                            <div className="feature-box">
                                <Coffee size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Salon de Thé</h4>
                                    <p>Pause douceur & mobilier rétro.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Landmark size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Vue Cathédrale</h4>
                                    <p>Terrasse imprenable sur Albi.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Croissant size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Brunch</h4>
                                    <p>Samedi & dimanche matin.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <ParkingSquare size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Parking gratuit</h4>
                                    <p>Arnaud Beltrame à proximité.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Accessibility size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Accès PMR</h4>
                                    <p>Boutique 100% accessible.</p>
                                </div>
                            </div>

                            {/* Duplicate Set to ensure no gaps */}
                            <div className="feature-box">
                                <Coffee size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Salon de Thé</h4>
                                    <p>Pause douceur & mobilier rétro.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Landmark size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Vue Cathédrale</h4>
                                    <p>Terrasse imprenable sur Albi.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Croissant size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Brunch</h4>
                                    <p>Samedi & dimanche matin.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <ParkingSquare size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Parking gratuit</h4>
                                    <p>Arnaud Beltrame à proximité.</p>
                                </div>
                            </div>
                            <div className="feature-box">
                                <Accessibility size={40} className="feature-icon" strokeWidth={1.5} />
                                <div>
                                    <h4>Accès PMR</h4>
                                    <p>Boutique 100% accessible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Info;
